import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useState } from "react";
import Flex from "../Flex";
import { StyledText } from "../ProfileViewer";
import { LOGIN_TOKENS } from "../../tokens/design-tokens";

type MaskedPasswordTextProps = {
  value?: string;
};

const MaskedPasswordText = ({ value }: MaskedPasswordTextProps) => {
  const [isVisible, setIsVisible] = useState(false);

  if (!value) return <StyledText>-</StyledText>;

  return (
    <Flex alignItems="center" gap={0.6}>
      <StyledText>{isVisible ? value : "•".repeat(value.length)}</StyledText>
      {isVisible ? (
        <VisibilityOff onClick={() => setIsVisible(false)} sx={eyeIconStyle} />
      ) : (
        <Visibility onClick={() => setIsVisible(true)} sx={eyeIconStyle} />
      )}
    </Flex>
  );
};

export default MaskedPasswordText;

const eyeIconStyle = {
  cursor: "pointer",
  color: LOGIN_TOKENS.color.iconGrey,
  fontSize: LOGIN_TOKENS.fontSize.iconSm,
};
